<template>
  <div class="rgg-page">
    <div class="rgg-page__inner">
      <header class="rgg-header">
        <div class="rgg-header__inner">
          <h1 class="rgg-header__title" :class="{'rgg-header__title--online' : online}"
          @click="navigateToTwitchChannel">Retro Game Gauntlet <span>console edition</span></h1>
          <nav class="rgg-header__menu rgg-header-menu">
            <ul class="rgg-header-menu__list">
              <li class="rgg-header-menu__item">
                <a :href="ruleLink" class="rgg-header-menu__link" target="_blank">Правила</a>
              </li>
              <li class="rgg-header-menu__item">
                <a :href="wheelLink" class="rgg-header-menu__link" target="_blank">Пункты колеса</a>
              </li>
              <li class="rgg-header-menu__item">
                <a class="rgg-header-menu__link" href="https://www.donationalerts.com/r/ukionik" target="_blank"
                >Активировать колесо приколов</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <div class="rgg-seasons-links">
        <router-link v-for="season in seasons" :key="season.number"
                     v-slot="{ href, navigate, isActive}"
                     :to="{ name: 'Season', params: { seasonNumber: season.number} }" custom>
          <div class="rgg-seasons-links__item">
            <h3 :class="{'rgg-season-title--active' : isActive}" class="rgg-season-title">
              <a :href="href" @click="navigate">Сезон {{ season.number }}</a>
            </h3>
          </div>
        </router-link>
      </div>
      <router-view/>
    </div>
  </div>
  <ModalsContainer/>
</template>

<script>

import ApiService from "@/services/api-service";
import {ModalsContainer} from "vue-final-modal";
import TwitchApiService from "@/services/twitch-api-service";

export default {
  name: 'App',
  components: {ModalsContainer},
  data: function () {
    return {
      selectedSeasonNumber: null,
      seasons: [],
      online: false,
      twitchUserName: "ukionik"
    }
  },
  computed: {
    twitchUrl: function(){
      return `https://twitch.tv/${this.twitchUserName}`
    },
    ruleLink: function () {
      if (this.selectedSeasonNumber === 1) {
        return "https://docs.google.com/spreadsheets/d/1nf6y3mzqvp5jCQu1dgdpL_3Ab6HolgvbOVrfN7s4wW4/edit#gid=0"
      } else {
        return "https://docs.google.com/document/d/1HqDq9aCydC1H3bCrWSUhpZyjvgHGLMX3rSVwZe_45MM/edit?usp=sharing"
      }
    },
    wheelLink: function () {
      if (this.selectedSeasonNumber === 1) {
        return "https://docs.google.com/spreadsheets/d/1nf6y3mzqvp5jCQu1dgdpL_3Ab6HolgvbOVrfN7s4wW4/edit#gid=1456808577"
      } else {
        return "https://docs.google.com/spreadsheets/d/1Pp2X74eDkX2kedfx2X80-77D3lXEi-8ONHjbGPIGbVk/edit?usp=sharing"
      }
    }
  },
  methods:{
    navigateToTwitchChannel(){
      window.open(this.twitchUrl, '_blank').focus();
    },
    async checkIfOnline(){
      this.online = await TwitchApiService.isOnline(this.twitchUserName)
    }
  },
  created() {
    this.$watch(
        () => this.$route.params,
        (toParams) => {
          this.selectedSeasonNumber = parseInt(toParams.seasonNumber)
        }
    )
  },
  mounted() {
    ApiService.get("rgg/seasons").then(response => {
      this.seasons = response.data
    })

    TwitchApiService.connect()
    this.checkIfOnline()
    setInterval(this.checkIfOnline, 60 * 1000)
  }
}
</script>

<style></style>
